import {
    getProductCategories,
    GetProductPropertiesApiParameter,
    ProductCategoriesModel,
} from "@hardware/Services/CustomProductService";
import {
    createHandlerChainRunner,
    HandlerWithResult,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";

type HandlerType = HandlerWithResult<
    {
        productIds: string[];
        type: string;
    } & HasOnSuccess<ProductCategoriesModel> &
        HasOnError<string>,
    {
        result?: ProductCategoriesModel;
        errorMessage?: string;
    }
>;

export const SendDataToApi: HandlerType = async props => {
    const result = await getProductCategories({
        productIds: props.parameter.productIds,
        type: props.parameter.type,
    } as GetProductPropertiesApiParameter);

    if (result.successful) {
        props.result = result;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.(props.result.result!);
};

export const chain = [SendDataToApi, ExecuteOnSuccessCallback];

const customGetProductCategories = createHandlerChainRunner(chain, "CustomGetProductCategories");
export default customGetProductCategories;
